/**
 * Shared scan feedback (vibration + short tone) for the mobile screens, so a
 * result can be felt/heard without looking at the screen. Best-effort only:
 * both are silently skipped where the device or browser doesn't allow them.
 */
export type FeedbackKind = 'good' | 'warn' | 'bad' | 'neutral';

let audio: AudioContext | null = null;

export function beep(kind: FeedbackKind): void {
  if (kind === 'neutral') return;
  try {
    const Ctx = window.AudioContext ?? (window as unknown as { webkitAudioContext?: typeof AudioContext }).webkitAudioContext;
    if (!Ctx) return;
    audio = audio ?? new Ctx();
    const osc = audio.createOscillator();
    const gain = audio.createGain();
    osc.frequency.value = kind === 'good' ? 880 : kind === 'warn' ? 520 : 220;
    gain.gain.value = 0.08;
    osc.connect(gain);
    gain.connect(audio.destination);
    osc.start();
    osc.stop(audio.currentTime + (kind === 'bad' ? 0.35 : 0.12));
  } catch {
    // no audio — vibration and colour still tell the story
  }
}

export function buzz(kind: FeedbackKind): void {
  if (navigator.vibrate) navigator.vibrate(kind === 'bad' ? [120, 60, 120] : kind === 'warn' ? [60, 40, 60] : 40);
}

/** Vibrate + beep together. */
export function signal(kind: FeedbackKind): void {
  buzz(kind);
  beep(kind);
}
